/**
 * roro-cart-drawer — «Доповніть замовлення»: quick add y carrusel arrastrable.
 *
 * TODO por delegación en `document`, sin init por nodo. El contenido del cajón
 * se re-renderiza entero en cada `cart:update` (morphing por Section Rendering
 * API), así que cualquier listener colgado de una tarjeta o de la pista muere
 * en el primer añadido. `scroll` no burbujea, pero sí se captura, así que hasta
 * el indicador de progreso funciona sin volver a montarse.
 *
 * El contrato de `cart:update` está en `rules/liquid-patterns.md`
 * («Actualizar el contador del carrito desde código propio»): recuento
 * ABSOLUTO releído de /cart.js y sin `source: 'product-form-component'`, que
 * hace que `<cart-icon>` sume en vez de asignar.
 */
(function () {
  'use strict';

  var PENDING = 'is-loading';
  var DRAG_THRESHOLD = 4;

  /* ==================================================================== */
  /* Carrusel arrastrable                                                 */
  /* ==================================================================== */

  var drag = {
    track: null,
    down: false,
    moved: false,
    startX: 0,
    startScroll: 0,
    lastX: 0,
    lastT: 0,
    velocity: 0,
    inertiaId: null
  };

  /** Un arrastre no debe disparar el «Додати в кошик» ni abrir la ficha. */
  var suppressClick = false;

  /**
   * Coloca y dimensiona el thumb: el ancho es la proporción visible del total y
   * la posición es el avance real del scroll.
   * @param {HTMLElement} track
   */
  function updateProgress(track) {
    var root = track.closest('[data-rcd-upsell]');
    if (!root) return;

    var bar = root.querySelector('[data-rcd-progress]');
    var thumb = root.querySelector('[data-rcd-progress-thumb]');
    if (!bar || !thumb) return;

    var maxScroll = track.scrollWidth - track.clientWidth;

    // Sin desbordamiento no hay nada que indicar.
    if (maxScroll <= 1) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;

    var ratio = Math.max(0, Math.min(1, track.scrollLeft / maxScroll));
    var visible = track.clientWidth / track.scrollWidth;
    // Topes para que el thumb no quede ni invisible ni casi tan ancho como la pista.
    var widthPct = Math.max(18, Math.min(60, visible * 100));

    thumb.style.width = widthPct + '%';
    thumb.style.left = ratio * (100 - widthPct) + '%';
    bar.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
  }

  var progressTicking = false;

  /** @param {HTMLElement} track */
  function scheduleProgress(track) {
    if (progressTicking) return;
    progressTicking = true;
    requestAnimationFrame(function () {
      updateProgress(track);
      progressTicking = false;
    });
  }

  /**
   * El cajón nace con `display: none`, así que al cargar la página la pista mide
   * 0 y la barra se calcula como «no hay nada que desplazar». Nada dispara una
   * segunda medición al abrirlo, y la barra se quedaba oculta para siempre. Un
   * `ResizeObserver` es exactamente el evento que faltaba: salta cuando la
   * pista pasa de 0 a su ancho real, y también al girar el móvil.
   */
  var observedTracks = new WeakSet();
  var trackObserver =
    typeof ResizeObserver === 'function'
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            updateProgress(/** @type {HTMLElement} */ (entry.target));
          });
        })
      : null;

  function updateAllProgress() {
    document.querySelectorAll('[data-rcd-track]').forEach(function (track) {
      // Tras un morphing la pista es un nodo nuevo y hay que volver a observarla.
      if (trackObserver && !observedTracks.has(track)) {
        observedTracks.add(track);
        trackObserver.observe(track);
      }
      updateProgress(track);
    });
  }

  function stopInertia() {
    if (drag.inertiaId) {
      cancelAnimationFrame(drag.inertiaId);
      drag.inertiaId = null;
    }
  }

  function startInertia() {
    var v = drag.velocity;
    var track = drag.track;
    if (!track || Math.abs(v) < 0.6) return;

    var step = function () {
      v *= 0.94;
      track.scrollLeft -= v;
      if (Math.abs(v) > 0.4) {
        drag.inertiaId = requestAnimationFrame(step);
      } else {
        drag.inertiaId = null;
        // Devolver el snap al final del deslizamiento, no durante.
        track.classList.remove('is-dragging');
      }
    };
    drag.inertiaId = requestAnimationFrame(step);
  }

  function endDrag() {
    if (!drag.down) return;
    drag.down = false;

    var track = drag.track;
    if (!track) return;

    if (!drag.moved) {
      track.classList.remove('is-dragging');
      return;
    }

    suppressClick = true;
    startInertia();
    if (!drag.inertiaId) track.classList.remove('is-dragging');
  }

  document.addEventListener('pointerdown', function (event) {
    // El táctil usa el scroll nativo del navegador: se siente como un feed y ya
    // trae su propio momentum. Aquí solo se emula el arrastre con ratón.
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    var target = event.target;
    if (!(target instanceof Element)) return;

    var track = target.closest('[data-rcd-track]');
    if (!track) return;

    stopInertia();
    drag.track = track;
    drag.down = true;
    drag.moved = false;
    drag.startX = event.clientX;
    drag.lastX = event.clientX;
    drag.lastT = performance.now();
    drag.velocity = 0;
    drag.startScroll = track.scrollLeft;
    suppressClick = false;
  });

  window.addEventListener(
    'pointermove',
    function (event) {
      if (!drag.down || !drag.track) return;

      var dx = event.clientX - drag.startX;

      if (!drag.moved) {
        if (Math.abs(dx) <= DRAG_THRESHOLD) return;
        drag.moved = true;
        // `scroll-snap-type: x mandatory` pelea contra un `scrollLeft` movido a
        // mano: el navegador reencaja en cada frame y el arrastre da tirones.
        // La clase lo desactiva mientras dura, y el snap vuelve al soltar.
        drag.track.classList.add('is-dragging');
      }

      event.preventDefault();
      drag.track.scrollLeft = drag.startScroll - dx;

      var now = performance.now();
      var dt = now - drag.lastT;
      if (dt > 0) {
        drag.velocity = ((event.clientX - drag.lastX) / dt) * 16;
        drag.lastX = event.clientX;
        drag.lastT = now;
      }
    },
    { passive: false }
  );

  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);

  // `scroll` no burbujea, pero se captura: un solo listener sirve para
  // cualquier pista, exista ahora o la pinte un morphing dentro de un rato.
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target instanceof Element && target.matches('[data-rcd-track]')) {
        scheduleProgress(target);
      }
    },
    true
  );

  // Evita el arrastre nativo de imágenes y enlaces dentro de la pista.
  document.addEventListener('dragstart', function (event) {
    var target = event.target;
    if (target instanceof Element && target.closest('[data-rcd-track]')) {
      event.preventDefault();
    }
  });

  // Fase de captura: corta el click antes de que llegue al botón o al enlace.
  document.addEventListener(
    'click',
    function (event) {
      if (!suppressClick) return;
      var target = event.target;
      if (!(target instanceof Element) || !target.closest('[data-rcd-track]')) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  // Saltar a un punto de la pista pinchando en la barra.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var bar = target.closest('[data-rcd-progress]');
    if (!bar) return;

    var root = bar.closest('[data-rcd-upsell]');
    var track = root && root.querySelector('[data-rcd-track]');
    if (!track) return;

    var rect = bar.getBoundingClientRect();
    var ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
    track.scrollTo({ left: ratio * (track.scrollWidth - track.clientWidth), behavior: 'smooth' });
  });

  window.addEventListener('resize', updateAllProgress);

  // Al abrir el cajón la pista pasa de 0 a su ancho real. El `ResizeObserver`
  // lo detecta, pero sus callbacks se entregan dentro de los pasos de render
  // del navegador: en una pestaña que no renderiza (segundo plano, un panel de
  // preview sin componer) no llegan nunca, igual que `requestAnimationFrame`.
  // `dialog:open` sí es síncrono. Va en fase de CAPTURA porque `DialogOpenEvent`
  // se emite sin `bubbles`, y un evento que no burbujea sigue bajando por la
  // fase de captura hasta su destino.
  document.addEventListener('dialog:open', updateAllProgress, true);

  document.addEventListener('cart:update', function () {
    // `setTimeout(0)` y no una llamada directa: `cart-items-component` escucha
    // el MISMO evento y hace el morphing de forma síncrona dentro de su
    // listener. Sin orden garantizado entre los dos, medir aquí mismo puede
    // caer antes del morphing y dimensionar el nodo viejo, dejando la pista
    // nueva sin barra. Una macrotarea corre después de todos los listeners
    // síncronos del evento. Tampoco vale `requestAnimationFrame`: no dispara
    // en una pestaña que no renderiza.
    setTimeout(updateAllProgress, 0);
  });

  /* ==================================================================== */
  /* Piezas que solo se venden en set                                     */
  /* ==================================================================== */

  /*
   * El platillo (o cualquier producto con la etiqueta `set-only`) no se vende
   * solo: si el carrito se queda únicamente con piezas así, se vacía. Lo
   * decide Liquid (`snippets/roro-set-only.liquid`) y lo escribe como
   * `set_only_alone` en el `<script data-roro-cart-state>` del cajón. Llega en
   * `detail.resource` después de cualquier añadido (`RoroCart.cartAfterAdd`
   * lo saca de ese mismo script) y está en la página al cargar. Quitar líneas
   * desde el carrito lo resuelve `component-cart-items.js`.
   */
  var clearingSetOnly = false;

  function clearSetOnlyCart() {
    if (clearingSetOnly) return;
    clearingSetOnly = true;

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // Contrato de `rules/liquid-patterns.md`: recuento absoluto y el
        // carrito en `resource`. El carrito vacío ya no lleva la marca, así
        // que este evento no vuelve a entrar aquí.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'roro-set-only',
            data: { source: 'roro-set-only', itemCount: 0, didError: false }
          }
        }));
      })
      .catch(function () {})
      .then(function () { clearingSetOnly = false; });
  }

  document.addEventListener('cart:update', function (event) {
    var cart = event.detail && event.detail.resource;
    if (cart && cart.set_only_alone === true) clearSetOnlyCart();
  });

  function checkSetOnlyInPage() {
    var node = document.querySelector('[data-roro-cart-state]');
    if (!node) return;
    try {
      if (JSON.parse(node.textContent).set_only_alone === true) clearSetOnlyCart();
    } catch (e) {
      // Ilegible: no se toca el carrito.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSetOnlyInPage);
  } else {
    checkSetOnlyInPage();
  }

  document.addEventListener('DOMContentLoaded', updateAllProgress);
  updateAllProgress();

  /* ==================================================================== */
  /* Quick add                                                            */
  /* ==================================================================== */

  /**
   * Ids de sección de todos los `cart-items-component` de la página. Son los
   * que hay que pedir en el POST para que el cajón pueda morfear con la
   * respuesta.
   * @returns {string[]}
   */
  function sectionIds() {
    return Array.prototype.map
      .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean);
  }

  /**
   * @param {Element} root
   * @param {string} message
   */
  /**
   * Ninguna cadena visible se escribe aqui: `message` es o el texto que manda
   * Shopify (ya traducido por Shopify) o el `data-rcd-error-fallback` que pinta
   * `snippets/roro-cart-upsell.liquid` con el filtro `t`. Nunca un
   * `error.message` del motor de JS.
   *
   * @param {Element} root
   * @param {string} [message]
   */
  function showError(root, message) {
    var feedback = root.querySelector('[data-rcd-feedback]');
    if (!feedback) return;
    var text = message || feedback.getAttribute('data-rcd-error-fallback') || '';
    if (!text) return;
    feedback.hidden = false;
    feedback.textContent = text;
  }

  /** @param {Element} root */
  function clearError(root) {
    var feedback = root.querySelector('[data-rcd-feedback]');
    if (!feedback) return;
    feedback.hidden = true;
    feedback.textContent = '';
  }

  /**
   * @param {object | null} cart
   * @param {object | undefined} sections
   */
  function notifyCart(cart, sections) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || undefined,
          sourceId: 'roro-cart-upsell',
          data: {
            source: 'roro-cart-upsell',
            itemCount: count === null ? 0 : count,
            didError: false,
            sections: sections
          }
        }
      })
    );

    if (count === null) return;

    var fallbacks = '[data-cart-count], .cart-count, #cart-icon-bubble, .cart-bubble__text-count';
    document.querySelectorAll(fallbacks).forEach(function (el) {
      // Solo nodos hoja: nunca sobrescribir marcado ajeno.
      if (el.children.length === 0) el.textContent = count < 100 ? String(count) : '99+';
      if (count > 0) el.classList.remove('hidden');
    });
  }

  /**
   * @param {HTMLButtonElement} button
   * @param {Element} root
   */
  function addToCart(button, root) {
    // La variante viene fijada desde Liquid (primera disponible): la tarjeta ya
    // no tiene ningún control de selección del que leerla.
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var addUrl = root.dataset.rcdAddUrl || '/cart/add.js';
    var cartUrl = root.dataset.rcdCartUrl || '/cart.js';
    var ids = sectionIds();

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (ids.length) body.sections = ids.join(',');

    button.disabled = true;
    button.classList.add(PENDING);
    clearError(root);

    // Sin `response.json()` suelto: si `/cart/add.js` contesta algo que no sea
    // JSON el `catch` pintaba `error.message`, o sea el mensaje INTERNO del
    // motor de JS — en WebKit, «The string did not match the expected pattern».
    // Ver `assets/roro-cart-fetch.js`.
    window.RoroCart.post(addUrl, body)
      .then(function (result) {
        if (!result.ok) {
          showError(root, window.RoroCart.message(result.data, null, ''));
          button.disabled = false;
          var idleLabel = button.querySelector('.roro-upsell__add-label');
          if (idleLabel && button.dataset.labelIdle) idleLabel.textContent = button.dataset.labelIdle;
          return;
        }

        var sections = result.data.sections;

        // Del HTML del cajón que ya trae la respuesta; `/cart.js` solo si no
        // viene. Ver `RoroCart.cartAfterAdd`.
        return window.RoroCart.cartAfterAdd(result).then(function (cart) {
          // Micro-confirmacion visual en el boton (cambia a checkmark)
          button.classList.add('is-done');
          setTimeout(function () {
            button.classList.remove('is-done');
          }, 800);

          var label = button.querySelector('.roro-upsell__add-label');
          var done = button.dataset.labelDone;
          if (label && done) label.textContent = done;
          notifyCart(cart, sections);
        });
      })
      .catch(function () {
        showError(root, '');
        button.disabled = false;
        var label = button.querySelector('.roro-upsell__add-label');
        if (label && button.dataset.labelIdle) label.textContent = button.dataset.labelIdle;
      })
      .then(function () {
        button.classList.remove(PENDING);
      });
  }

  /* ==================================================================== */
  /* Selector de variante del quick add                                   */
  /* ==================================================================== */

  /**
   * El selector NO puede vivir dentro de la tarjeta: la pista del carrusel
   * tiene `overflow-x: auto` y lo recortaría. Y tampoco puede ser el `na-sheet`
   * de las secciones: el cajón es un `<dialog>` abierto con `showModal()`, o
   * sea que está en el TOP LAYER, y cualquier cosa pintada fuera de él sale por
   * detrás por mucho z-index que lleve. La única posición válida es dentro del
   * propio `<dialog>`.
   *
   * Va colgado del `<dialog>` y no de `.cart-drawer__inner` a propósito: el
   * interior se re-renderiza entero en cada `cart:update` (morphing), y el
   * selector se lo llevaría por delante a mitad de uso.
   */
  var picker = {
    root: null,
    /** Botón «+» que lo abrió, para devolverle el foco al cerrar. */
    opener: null,
    closingTimer: null
  };

  var CLOSE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function closePicker(options) {
    if (!picker.root) return;

    var immediate = options && options.immediate;
    var root = picker.root;
    var opener = picker.opener;

    if (picker.closingTimer) {
      clearTimeout(picker.closingTimer);
      picker.closingTimer = null;
    }

    if (immediate) {
      root.remove();
      picker.root = null;
      picker.opener = null;
      if (opener && opener.isConnected) opener.focus();
      return;
    }

    if (root.classList.contains('is-closing')) return;

    root.classList.add('is-closing');
    picker.closingTimer = setTimeout(function () {
      if (picker.root === root) {
        root.remove();
        picker.root = null;
        picker.opener = null;
        picker.closingTimer = null;
      }
      if (opener && opener.isConnected) opener.focus();
    }, 220);
  }

  /**
   * @param {HTMLButtonElement} button - El «+» de la tarjeta.
   * @param {Element} upsell - La sección `[data-rcd-upsell]`, de donde salen las URLs.
   */
  function openPicker(button, upsell) {
    var card = button.closest('[data-rcd-card]');
    var template = card && card.querySelector('template[data-rcd-picker]');
    if (!template) return false;

    closePicker({ immediate: true });
    document.querySelectorAll('.roro-picker').forEach(function (el) {
      el.remove();
    });

    var closeLabel = upsell.dataset.rcdCloseLabel || '';

    var root = document.createElement('div');
    root.className = 'roro-picker';
    root.setAttribute('data-rcd-picker-root', '');
    // `data-rcd-upsell` para que el handler de añadir lo encuentre con
    // `closest()` igual que encuentra la sección: así el POST y el morphing
    // son exactamente los mismos, sin una segunda ruta que mantener.
    root.setAttribute('data-rcd-upsell', '');
    root.dataset.rcdAddUrl = upsell.dataset.rcdAddUrl || '';
    root.dataset.rcdCartUrl = upsell.dataset.rcdCartUrl || '';

    var scrim = document.createElement('div');
    scrim.className = 'roro-picker__scrim';
    scrim.setAttribute('data-rcd-picker-close', '');

    var panel = document.createElement('div');
    panel.className = 'roro-picker__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');

    var handle = document.createElement('div');
    handle.className = 'roro-picker__handle';
    handle.setAttribute('aria-hidden', 'true');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'roro-picker__close';
    close.setAttribute('data-rcd-picker-close', '');
    if (closeLabel) close.setAttribute('aria-label', closeLabel);
    close.innerHTML = CLOSE_ICON;

    var feedback = document.createElement('p');
    feedback.className = 'roro-picker__feedback';
    feedback.setAttribute('role', 'alert');
    feedback.setAttribute('data-rcd-feedback', '');
    feedback.hidden = true;

    panel.appendChild(handle);
    panel.appendChild(close);

    var fragment = template.content && template.content.cloneNode(true);
    if (!fragment || fragment.childNodes.length === 0) {
      var temp = document.createElement('div');
      temp.innerHTML = template.innerHTML;
      while (temp.firstChild) {
        panel.appendChild(temp.firstChild);
      }
    } else {
      panel.appendChild(fragment);
    }

    panel.appendChild(feedback);
    root.appendChild(scrim);
    root.appendChild(panel);

    var dialog = button.closest('dialog') || document.body;
    dialog.appendChild(root);

    var title = panel.querySelector('.roro-picker__title');
    if (title && title.textContent) panel.setAttribute('aria-label', title.textContent.trim());

    picker.root = root;
    picker.opener = button;

    var first = panel.querySelector('.roro-picker__option:not([disabled])');
    if (first) first.focus();

    return true;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-rcd-picker-close]')) {
      event.preventDefault();
      closePicker();
      return;
    }

    var button = target.closest('[data-rcd-add]');
    if (!button) return;

    var root = button.closest('[data-rcd-upsell]');
    if (!root) return;

    event.preventDefault();

    // El «+» de una tarjeta con más de una variante no añade nada: pregunta.
    if (button.hasAttribute('data-rcd-choose')) {
      if (openPicker(/** @type {HTMLButtonElement} */ (button), root)) return;
    }

    // Micro-feedback visual rápido (180ms flash: radio checkeado y borde de acento),
    // y luego el sheet baja suavemente (200-250ms), mientras el añadido corre de inmediato en segundo plano.
    if (button.classList.contains('roro-picker__option')) {
      button.classList.add('is-selected');
      setTimeout(function () {
        closePicker();
      }, 180);
    }

    addToCart(/** @type {HTMLButtonElement} */ (button), root);
  });

  // Escape cierra el selector, no el cajón. Hacen falta los dos: `keydown` en
  // captura para adelantarse a los listeners del drawer, y `cancel` para el
  // cierre nativo del `<dialog>`, que no pasa por ningún listener de teclado.
  document.addEventListener(
    'keydown',
    function (event) {
      if (!picker.root || event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      closePicker();
    },
    true
  );

  document.addEventListener(
    'cancel',
    function (event) {
      if (!picker.root) return;
      event.preventDefault();
      closePicker();
    },
    true
  );

  // Tras añadir, el cajón se repinta entero: el selector se cierra
  document.addEventListener('cart:update', function () {
    closePicker({ immediate: true });
  });

  /* ==================================================================== */
  /* Precarga de las fotos del upsell                                     */
  /* ==================================================================== */

  /**
   * POR QUE HACE FALTA
   *
   * Las tarjetas de «Доповніть замовлення» viven dentro del `<dialog>` del
   * cajón, que está cerrado (`display: none`) hasta que alguien lo abre. Para
   * el navegador eso significa que sus `<img loading="lazy">` NUNCA están en
   * pantalla, así que no descarga ni una: la primera petición sale en el mismo
   * instante en que el cajón se abre. En una conexión móvil eso son uno o dos
   * segundos con seis rectángulos en blanco justo debajo de los productos —
   * que es exactamente lo que se veía («solo sale el fondo blanco»,
   * 2026-09-08).
   *
   * QUE HACE
   *
   * Cuando el navegador está ocioso, cambia esas imágenes a `eager`. Son seis
   * miniaturas de ~124px de ancho; pedirlas después de que la página haya
   * terminado de cargar no compite con el LCP y deja el cajón lleno desde el
   * primer fotograma.
   *
   * Se ejecuta también en cada `cart:update` porque el interior del cajón se
   * re-renderiza entero (morphing) y las imágenes nuevas vuelven a llegar en
   * `lazy`. `data-rcd-warm` marca las ya tratadas para no repetir trabajo.
   */
  function warmUpsellImages() {
    var images = document.querySelectorAll('.roro-upsell__img[loading="lazy"]:not([data-rcd-warm])');

    for (var i = 0; i < images.length; i++) {
      images[i].setAttribute('data-rcd-warm', 'true');
      // `fetchpriority` bajo: importa que estén listas, no que lleguen antes
      // que nada de la página que el cliente sí está mirando.
      images[i].setAttribute('fetchpriority', 'low');
      images[i].setAttribute('loading', 'eager');
    }
  }

  function scheduleWarmUp() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(warmUpsellImages, { timeout: 3000 });
    } else {
      setTimeout(warmUpsellImages, 1200);
    }
  }

  if (document.readyState === 'complete') {
    scheduleWarmUp();
  } else {
    window.addEventListener('load', scheduleWarmUp, { once: true });
  }

  document.addEventListener('cart:update', scheduleWarmUp);

  /* ==================================================================== */
  /* Estado vacío o lleno del diálogo                                     */
  /* ==================================================================== */

  /**
   * POR QUE HACE FALTA (2026-09-28)
   *
   * El `<dialog>` del cajón lleva `cart-drawer--empty` y un `aria-labelledby`
   * que dependen de si hay carrito, y de esa clase cuelga todo el layout del
   * cajón vacío (`snippets/header-actions.liquid` y `roro-cart-drawer.css`).
   * Mientras cada añadido repintaba la cabecera entera, el morph ponía al día
   * el `<dialog>` de paso. Desde que se pide solo el interior
   * (`sections/roro-cart-drawer-render.liquid`), el `<dialog>` queda fuera de
   * lo que se repinta y hay que sincronizarlo aquí. Sin esto, el primer
   * añadido con el carrito vacío abría el cajón lleno con el layout del vacío.
   *
   * POR QUE UN MutationObserver Y NO `cart:update`
   *
   * El morph de `cart-items-component` y el `showModal()` del cajón cuelgan del
   * mismo evento sin orden garantizado. El observer entrega en microtarea, o
   * sea antes del `requestAnimationFrame` en el que `dialog.js` abre el cajón:
   * nunca se pinta un fotograma con la clase equivocada. Cubre además los
   * caminos que no emiten nada, como el vaciado optimista de Horizon (el
   * `<template id="empty-cart-template">` al quitar la última línea).
   *
   * Solo `childList`: los estilos y atributos que cambian dentro (barras de
   * progreso, el carrusel) no despiertan al observer.
   */
  var DRAWER_SECTION_ID = 'shopify-section-roro-cart-drawer-render';

  function syncDrawerState() {
    var wrapper = document.getElementById(DRAWER_SECTION_ID);
    var dialog = wrapper && wrapper.closest('dialog');
    if (!dialog) return;

    // El encabezado del cajón vacío solo existe cuando se pinta
    // `snippets/roro-cart-empty.liquid`; el lleno lleva `#cart-drawer-heading`.
    var empty = !!wrapper.querySelector('#cart-drawer-heading-empty');

    if (dialog.classList.contains('cart-drawer--empty') !== empty) {
      dialog.classList.toggle('cart-drawer--empty', empty);
    }

    var labelledBy = empty ? 'cart-drawer-heading-empty' : 'cart-drawer-heading';
    if (dialog.getAttribute('aria-labelledby') !== labelledBy) {
      dialog.setAttribute('aria-labelledby', labelledBy);
    }
  }

  function observeDrawerState() {
    var wrapper = document.getElementById(DRAWER_SECTION_ID);
    if (!wrapper || typeof MutationObserver !== 'function') return;

    new MutationObserver(syncDrawerState).observe(wrapper, { childList: true, subtree: true });
    syncDrawerState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawerState);
  } else {
    observeDrawerState();
  }
})();
